import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, MapPin, PenLine, CheckCircle2, Ruler } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const money = (n) => "$" + Math.round(Number(n || 0)).toLocaleString();

export default function DesignQuoteView() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const load = () => axios.get(`${BACKEND}/api/public/design-quote/${token}`).then((r) => { setData(r.data); if (r.data.acceptedAt) setAccepted(true); }).catch(() => setErr("报价链接无效或已失效"));
  useEffect(() => { load(); }, [token]); // eslint-disable-line

  const accept = async () => {
    setBusy(true);
    try { const { data: r } = await axios.post(`${BACKEND}/api/public/design-quote/${token}/accept`, { name: name.trim() }); if (r.ok) setAccepted(true); }
    catch { setErr("提交失败，请稍后重试或联系顾问。"); }
    setBusy(false);
  };

  if (err) return <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="design-quote-view-error">{err}</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-indigo-500" /></div>;

  const byArea = data.choice !== "manual";
  return (
    <div className="min-h-screen bg-slate-100" data-testid="design-quote-view-page">
      <div className="bg-slate-900 text-white px-5 py-4 flex items-center gap-2">
        <span className="font-bold text-red-500 text-lg">ALIGCUS</span>
        <div><p className="text-sm font-semibold">阿里建筑 · 建筑设计报价</p><p className="text-[11px] text-slate-300">ALIGCUS · Architectural Design Quote</p></div>
      </div>
      <div className="max-w-[680px] mx-auto p-4 space-y-4">
        <div className="bg-white rounded-2xl p-5 shadow-sm">
          <p className="text-[11px] text-slate-400">项目地址 PROJECT ADDRESS</p>
          <p className="text-xl font-bold text-slate-800 flex items-center gap-1.5"><MapPin className="h-4 w-4 text-indigo-500" />{data.address || data.clientName}</p>
          <p className="text-sm text-slate-500 mt-1">{data.clientName} · {data.branchZh}</p>
        </div>

        <div className="bg-white rounded-2xl p-5 shadow-sm" data-testid="design-quote-view-price">
          <p className="text-indigo-600 font-bold mb-3 flex items-center gap-1.5"><Ruler className="h-4 w-4" />设计费报价 Design Fee</p>
          {byArea ? (
            <div className="space-y-1.5 text-sm">
              <div className="flex justify-between py-1 border-b border-slate-50"><span className="text-slate-600">设计单价 Rate</span><span className="font-medium text-slate-800">{money(data.rate)} / sqft</span></div>
              <div className="flex justify-between py-1 border-b border-slate-50"><span className="text-slate-600">建筑面积 Area</span><span className="font-medium text-slate-800">{Math.round(data.area || 0)} sqft</span></div>
            </div>
          ) : (
            <div className="flex justify-between py-1 border-b border-slate-50 text-sm"><span className="text-slate-600">建筑设计费 Design Fee (per plan)</span><span className="font-medium text-slate-800">{money(data.manualFee)}</span></div>
          )}
          <div className="flex justify-between items-baseline mt-3">
            <span className="text-indigo-600 font-bold">设计费总价 Total Design Fee</span>
            <span className="text-2xl font-bold text-indigo-600" data-testid="design-quote-view-total">{money(data.total)}</span>
          </div>
        </div>

        {accepted ? (
          <div data-testid="design-quote-accepted" className="rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-800 px-4 py-4 text-center text-sm font-medium flex flex-col items-center gap-1.5">
            <CheckCircle2 className="h-6 w-6" />
            <span>感谢您的确认！我们的设计顾问将尽快与您对接，启动建筑设计工作。</span>
          </div>
        ) : (
          <div className="bg-white rounded-2xl p-5 shadow-sm space-y-3">
            <p className="text-sm text-slate-600">如确认以上设计费报价，请填写您的姓名并点击确认。</p>
            <input data-testid="design-quote-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="您的姓名 Your name"
              className="w-full text-sm rounded-lg border border-slate-200 px-3 py-2.5 focus:border-indigo-400 focus:outline-none" />
            <button onClick={accept} disabled={busy} data-testid="design-quote-accept"
              className="w-full flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 text-white rounded-xl py-3.5 font-bold text-base transition-colors shadow-sm">
              {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <><PenLine className="h-5 w-5" />确认接受设计费报价 Accept</>}
            </button>
          </div>
        )}
        <p className="text-center text-[11px] text-slate-400 pb-6">本报价仅含建筑设计服务费，最终以正式合同为准。<br />阿里建筑 ALIGCUS · 626-803-8000 / 408-900-6688</p>
      </div>
    </div>
  );
}
